import React from 'react';

interface FormFieldProps {
  label?: string;
  htmlFor?: string;
  error?: string | boolean;
  hint?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const FormField: React.FC<FormFieldProps> = ({ label, htmlFor, error, hint, children, style }) => {
  return (
    <div style={{ marginBottom: '0.9rem', ...style }}>
      {label && (
        <label htmlFor={htmlFor} className="field-label">
          {label}
          {typeof hint === 'string' && hint ? (
            <span style={{ marginLeft: 6, color: 'var(--text-muted)', fontWeight: 400 }}> {hint}</span>
          ) : null}
        </label>
      )}
      {children}
      {error ? (
        <div className="field-error">{typeof error === 'string' ? error : 'Invalid value'}</div>
      ) : null}
    </div>
  );
};

export default FormField; 